import { useState } from "react";
import { classNames } from "@/lib/format";
import { toast } from "@/lib/toast";
import { resetUiSections, useCollapsedUiSectionCount } from "@/lib/uiSections";

/**
 * Persönliche Einstellung: ausgeblendete Seitenbereiche (Filter, Kacheln …).
 * Zeigt die Anzahl und erlaubt, alle Bereiche wieder einzublenden.
 */
export function HiddenSectionsControl({ className }: { className?: string }) {
  const count = useCollapsedUiSectionCount();
  const [busy, setBusy] = useState(false);

  async function handleReset() {
    setBusy(true);
    try {
      await resetUiSections();
      toast.success("Alle Bereiche werden wieder angezeigt.");
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Zurücksetzen fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className={classNames("eh-account-section", className)}>
      <div className="flex items-center justify-between gap-3">
        <span className="min-w-0">
          <span className="eh-account-section-title mb-0 block">Ausgeblendete Bereiche</span>
          <span className="mt-0.5 block text-xs text-label-tertiary">
            {count === 0
              ? "Alle Filter und Kacheln werden angezeigt."
              : `${count} ${count === 1 ? "Bereich" : "Bereiche"} ausgeblendet – z. B. Filter oder Kacheln.`}
          </span>
        </span>
        <button
          type="button"
          onClick={() => void handleReset()}
          disabled={busy || count === 0}
          className="shrink-0 rounded-lg px-2.5 py-1.5 text-xs font-medium text-accent transition hover:bg-fill-tertiary disabled:cursor-not-allowed disabled:opacity-50"
        >
          {busy ? "…" : "Alle einblenden"}
        </button>
      </div>
    </section>
  );
}
